
import { Product } from "@/types/product";
import { hdbasetKits } from "./kits";
import { hdbasetTransmitters } from "./transmitters";
import { hdbasetReceivers } from "./receivers";
import { hdbasetAccessories } from "./accessories";

// Combine all HDBaseT products
export const hdbasetProducts: Product[] = [
  ...hdbasetKits,
  ...hdbasetTransmitters,
  ...hdbasetReceivers,
  ...hdbasetAccessories
];

// Export individual product categories
export { hdbasetKits } from "./kits";
export { hdbasetTransmitters } from "./transmitters";
export { hdbasetReceivers } from "./receivers";
export { hdbasetAccessories } from "./accessories";
